'use client'

import { ProductImageGallery } from '@components/category'
import { stringToHash } from '@utils/contentful/stringToHash'
import React, { useRef } from 'react'
import { StickyScroll } from './StickyScroll'
import { useDevice } from '@utils/responsiveness/useDevice'
import { IProductEntry } from 'app/_services/CMS/contentful/types/productEntry'

const GALLERY_SECTION_LABEL = 'Gallery'

export function ProductPage({
  productData,
  productDetailsSection,
  topProductFeatures,
  footerProductFeatures,
}: {
  productData: IProductEntry
  productDetailsSection: React.ReactNode
  topProductFeatures: React.ReactNode
  footerProductFeatures: React.ReactNode
}) {
  const { isMobile } = useDevice({
    mobileMediaQuery: 480,
    tabletMediaQuery: 1279,
  })
  const configurableSectionRef = useRef<HTMLDivElement>()

  const { productName, productHeroImages } = productData

  return (
    <>
      <div className="bg-core-beige">
        <div
          id={stringToHash(GALLERY_SECTION_LABEL)}
          className="grid grid-cols-1 lg:grid-cols-[minmax(0,_1fr)_minmax(485px,_30%)] bg-white"
        >
          <div className="col-span-1 col-start-1 row-start-1">
            <ProductImageGallery
              images={productHeroImages}
              showNav={true}
              showFullScreenBtn={!isMobile}
              key={productName}
            />
          </div>

          <div ref={configurableSectionRef}>{topProductFeatures}</div>

          <div className="z-10 col-start-1 row-span-3 row-start-2 lg:col-start-2 lg:row-start-1 bg-white">
            <StickyScroll configurableSectionRef={configurableSectionRef}>
              {productDetailsSection}
            </StickyScroll>
          </div>
        </div>

        {footerProductFeatures}
      </div>
    </>
  )
}
